import { render } from "./SMSPackageDialog.vue?vue&type=template&id=a585649e&scoped=true&ts=true"
import script from "./SMSPackageDialog.vue?vue&type=script&lang=ts"
export * from "./SMSPackageDialog.vue?vue&type=script&lang=ts"

import "./SMSPackageDialog.vue?vue&type=style&index=0&id=a585649e&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a585649e"]])

export default __exports__